module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-03.69f3c914.jpg";